<template>
  <page-outline :title="$t('Detail Historique Transaction')"
    iconFA="address-book">
      <template slot="pageContent">
                  <template v-if="TransactionList.length > 0" >
                    <br>
                    <td >Informations payement :</td>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Nom crediteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.creditor_name }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Identifiant crediteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.creditor_identifier }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Compte Bancaire crediteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.creditor_bank_account }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Bic créditeur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.creidtor_bic }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Nom Debiteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.debtor_name }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Identifiant débiteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.debtor_identifier }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Bic debiteur') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.debtor_bic }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Référence client') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.customer_reference }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Date de création') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.creation_date }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('end_to_end_id') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.end_to_end_id }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Remittance') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.remittance_information }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Date d\'execution') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.request_execution_date }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Montant') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.amount }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Monnaie') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.currency }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <table class="User">
                      <tbody>
                          <tr>
                            <th class="text-center" style="width:300px">
                              {{ $t('Status') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ label(TransactionList[0].payment.status) }}
                            </td>
                            <th class="text-center" style="width:300px">
                              {{ $t('Direction') }}
                            </th>
                            <td class="text-center" style="width:250px">
                              {{ TransactionList[0].payment.direction }}
                            </td>
                          </tr>
                      </tbody>
                    </table>
                    <br>
                    <td>Historique :</td>
                    <table class="User-habilitation">
                      <thead>
                          <tr>
                            <th class="text-center" style="width:200px">
                              {{ $t('Status') }}
                            </th>
                            <th class="text-center" style="width:200px">
                              {{ $t('Date de création') }}
                            </th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-for="result in TransactionList[0].history"
                          :key="result"
                          class="boxRequest">
                          <td class="text-center" :title="result.payment_history.status">{{ label(result.payment_history.status) }}</td>
                          <td class="text-center" :title="result.payment_history.creation_date">{{ result.payment_history.creation_date }}</td>
                        </tr>
                      </tbody>
                  </table>
                  </template>
                </template>
</page-outline>
</template>

<script>
import {statusLabel} from '@/helpers/labels'
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'


export default {
  name: 'TransactionHistoryDetail',
  components: {
    'page-outline': PageOutline
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    }
  },
  props: ['id'],
  data () {
    return {
      activateSpinner: false,
      TransactionList: []
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details Historique Transaction',
      returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.atStart(this.id)
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    label (status) {
      return statusLabel(this.$i18n, status)
    },
    atStart (val = 1) {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      console.log('ici!!')
      that.$engine.usercompany.idUserAcc = val
      this.TransactionList = []
      let filterConditions = that.$engine.usercompany.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.transactionhistorylist.getTransactionHistoryList(
        this.id,
        10,
        1
      ).then(resp => {
        let requests = {}
        // resp.data.UserCompany.idUserAcc = that.$engine.usercompany.idUserAcc
        if (resp.data && resp.data.TransactionHistoryList) {
          resp.data.TransactionHistoryList.history.forEach(item => {
            item.payment_history.creation_date = moment(item.payment_history.creation_date).format('DD/MM/yyyy HH:mm:ss')
          })
          requests = resp.data.TransactionHistoryList
          that.TransactionList.push(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    }
  }
}
</script>

<style scoped>
.User {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  width: 100%;
}

.User th {
  background-color: black;
  color: white;
  font-weight: normal;
  height: 40px;
}

.User tbody tr td {
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: white;
}

.User tbody tr td,.User thead th {
  text-align: center;
}

.User-habilitation {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  width: 100%;
}

.User-habilitation th {
  background-color: black;
  border: 1px solid silver;
  color: white;
  font-weight: normal;
  height: 40px;
}

.User-habilitation tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: white;
}

.User-habilitation tbody tr td,.User thead th {
  text-align: center;
}

.filterType .label {
  width: 40%;
}
.icon-status-label {
  width: 22px;
  height: 22px;
  background-size: contain;
  margin-top: -4px;
  /* vertical-align: baseline !important; */
}

.list-block .item-title.label {
  width: auto;
}

::-webkit-input-placeholder {
  color: #A7A7A7;
}

label {
  margin-bottom: 0%;
}

.filter {
  width: 100%;
  border-radius: 0px;
  margin: 0px;
}

.filter-item-title {
  color: var(--actionTextColor);
  font-weight: 700;
}
.filter-item-content {
  color: #969696;
}
.filter-item-section {
  background-color: #f2f2f2;
}
.filter-item {
  display: inline-flex;
  flex-direction: column;
  padding-right: 2rem;
  flex: 1 1 auto;
}
input.filter-item-input, textarea.filter-item-input {
  height:auto;
  line-height:inherit;
  color:inherit;
  font-size:inherit;
}
input.filter-item-input-complete, span.filter-item-input-complete, textarea.filter-item-input-complete {
  color:#000;
}
textarea {
  max-height: 2.5em;
  line-height: inherit;
  padding: 0 0 0 0;
}
.filter-selection {
  z-index:150;
}

.icon {
  min-height: 20px;
  min-width: 20px;
}

i.icon.fa.fa-filter {
  line-height: inherit;
  font-size: 1.3em;
  padding-right: 15px;
}

#status-chevron {
  font-size: inherit;
  line-height: inherit;
  color:inherit;
}

.row {
  margin: 0;
}
</style>
